import React, { Suspense } from "react";
import TeacherLayout from "../../layout/TeacherLayout";
import { Outlet } from "react-router-dom";
import AuthGuard from "../../layout/auth-guard";

const Fallback = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    {/* <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div> */}
  </div>
);

const SplashScreenTeacher = () => {
  return (
    <AuthGuard>
      <TeacherLayout>
        <Suspense fallback={<Fallback />}>
          <Outlet />
        </Suspense>
      </TeacherLayout>
    </AuthGuard>
  );
};

export default SplashScreenTeacher;
